export enum ExperimentVariant {
    VARIANT_A = 'A',
    VARIANT_B = 'B',
    VARIANT_C = 'C',
    VARIANT_D = 'D',
}

export const GrowthBookFeature = {
    REVIEW_FEATURE_FLAG: 'GTC-2380',
    UNREAD_FEATURE_FLAG: 'GTC-2379',
    FORGOTTEN_PASSWORD_FLAG: 'GTC-2643',
    G5S: 'G5S-17',
    LOGOUT_TO_BFF: 'GTCON-20',
    EXPIRED_ADS_BANNER: 'GTS-74',
    MCUFEED_CTA_CHANGE: 'GTCON-91',
    DATE_OF_BIRTH_INPUT: 'GTCON-42',
    HIDE_SMS: 'GTCON-274',
    NEW_FEATURES_COPY: 'GTS-142',
    LISTING_CAP_MODAL: 'GTS-105',
    REVEAL_NUMBER_LABEL: 'GTCON-331',
    POSTCODE_INPUT: 'GTCON-275',
    GOOGLE_REVIEW: 'google-review',
    GOOGLE_REVIEW_SRP: 'google-review-srp',
    // sug search
    SUG_WITHOUT_CATEGORY: 'sug_without_category',
    BLOCKTHROUGH_JS: 'blockthrough-ad-script',
    SERVICE_NEW_UI: 'service-new-ui',
    CARMONEY_MONTHLY_PRICE: 'carmoney-monthly-price',
    CARMONEY_ABOVE_MAP: 'carmoney-above-map',
    SOVRN_SWITCH_DURATION: 'sovrn-switch-duration',
    SRP_REMOVE_POSTDATE: 'srp_remove_postdate',
    // motors cta optimization
    MOTORS_CTA_OPT: 'motors-cta-opt',
    MOTORS_POST_CALL_ENCOURAGE: 'motors-post-call-encourage',
    MOTORS_OUT_OF_CORE_HOUR: 'motors-out-of-core-hour',
} as const;

export const GrowthBookServerSideFeatures = {
    PHONE_MODEL: 'srp_filter_mobile_apple_samsung_model',
    PHONE_MODEL_A: 'srp_filter_mobile_model_google_xiaomi_huawei',
    SYI_CATE_SUG: 'syi_cate_sug_flag',
    KEYWORD_CORRECTION: 'GTF-2399',
    SYI_AI_POST: 'syi-ai-post',
    SUG_USE_NEW_RANK: 'sug_use_new_rank',
    SUG_USE_NEW_INDEX: 'sug_use_new_index',
    SUG_ALL_PLATFORM_ALIGN: 'sug_all_platform_align',
    SYI_DIY_CONDITION: 'srp_filter_diy_tools_materials_condition',
    HOME_GARDEN_ATTRS: 'srp_filter_home_garden_condition_colour_material',
    FASHION_ATTRS: 'srp_filter_fashion_condition_colour_material_size',
    SEO_BROWSE_LINK: 'seo-browse-related-link',
    GEO_OUTSIDE_SEARCH_RADIUS: 'geo_outside_search_radius',
    GEO_ZIPCODE_RADIUS: 'geo_zipcode_radius',
    SRP_ENTITY_RANK: 'srp_entity_rank',
    SRP_ENTITY_RECALL: 'srp_entity_recall',
    SRP_RELEVANCE_APPLY_PAGE2: 'srp_revelance_apply_page2',
} as const;
